import { TextField, NumberInput, TextInput } from "react-admin";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import { MyList } from "../ra-lb-tools/components/myList";
import {
  MyReferenceField,
  MyReferenceInput,
} from "../ra-lb-tools/components/myReference";

export const UserRoleIcon = VpnKeyIcon;

const filters = [
  <NumberInput source="id" key="id" alwaysOn />,
  <TextInput source="name" key="name" alwaysOn />,
];

export const UserRoleList = (props) => {
  return (
    <MyList resource="user-roles" filters={filters} {...props}>
      <TextField source="id" />
      <TextField source="name" />
    </MyList>
  );
};

export const UserRoleInput = (props) => {
  return <MyReferenceInput reference="user-roles" {...props} />;
};

export const UserRoleField = (props) => {
  return <MyReferenceField reference="user-roles" {...props} />;
};
